import { gql } from '@apollo/client';

export const BusinessQuestionsFragment = gql`
  fragment BusinessQuestions on BusinessQuestions {
    fiscalYearEndMonth
    gustoCompanyId
  }
`;
